<div class="cards">
  <ix-smb-card></ix-smb-card>
  <ix-nfs-card></ix-nfs-card>
  <ix-iscsi-card></ix-iscsi-card>
</div>
